import { Button } from "react-bootstrap";

const DriverExpensesHeader = ({ searchTerm, onSearchChange, total, onAddDriverExpense }) => {
  return (
    <div className="card-header d-flex justify-content-between align-items-center">
      <h4 className="card-title mb-0">Driver Expenses ({total})</h4>

      <div className="d-flex gap-2 align-items-center">
        <input
          type="text"
          className="form-control w-auto"
          placeholder="Search driver expenses"
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
        />
        <Button type="button" onClick={onAddDriverExpense}>
          + Add Driver Expense
        </Button>
      </div>
    </div>
  );
};

export default DriverExpensesHeader;
